// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./global/confirmation";
import "./global/flash";
import "./global/header";
import "./global/auto_submit";
import "./global/rate_limit_handler";
import "./pages/settings";
import "./pages/dashboard";
import "./pages/leaderboard";
import "./pages/test";
import "./pages/test_runner";
import "./pages/library";
import "./pages/referrals";

import { initDashboard } from "./pages/dashboard";
import { initLeaderboard } from "./pages/leaderboard";
import { initStarRating } from "./pages/star_rating";
import { initLibrary } from "./pages/library";
import { initStudio } from "./pages/studio";
import { initResults } from "./pages/results";
import { TestEditor } from "./pages/test_editor";
import { initActivityHeatmap } from "./components/activity_heatmap";

document.addEventListener("turbo:load", () => {
  document.body.dataset.jsLoaded = "true";

  const editorRoot = document.getElementById("test-editor-root");
  if (editorRoot) {
    const editor = new TestEditor(editorRoot);
    editor.ready().then(() => {
      document.body.dataset.editorReady = "true";
    });
  }

  // Initialize page-specific modules
  initDashboard();
  initLeaderboard();
  initStarRating();
  initLibrary();
  initStudio();
  initResults();
  initActivityHeatmap();
});
